import { render, staticRenderFns } from "./EventPeopleSection.vue?vue&type=template&id=5b2958c4&"
import script from "./EventPeopleSection.vue?vue&type=script&lang=js&"
export * from "./EventPeopleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports